import { render, staticRenderFns } from "./product.vue?vue&type=template&id=13f9d280&scoped=true&"
import script from "./product.vue?vue&type=script&lang=js&"
export * from "./product.vue?vue&type=script&lang=js&"
import style0 from "./product.vue?vue&type=style&index=0&id=13f9d280&prod&scoped=true&lang=stylus&"
import style1 from "./product.vue?vue&type=style&index=1&id=13f9d280&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f9d280",
  null
  
)

export default component.exports